import { FormattedMessage } from "react-intl";
import React from "react";

const actions = {
  upgrade: {
    link: "/billing/plans",
    name: "upgrade",
  },
  addMember: {
    link: "/billing/info?addLicense=true",
    name: "organization.addMember",
    className: "without-gradient",
    style: { borderColor: "#3b53d1", color: "#3b53d1" },
  },
  getMorePhoneCredit: {
    link: "/billing/plans/credits/phone",
    name: "navbar.getMorePhoneCredit",
    className: "with-purple",
    style: { borderColor: "rgb(177, 73, 255)", color: "rgb(177, 73, 255)" },
  },
  getMoreCredit: {
    link: "/billing/plans/credits/phone",
    name: "navbar.getMoreCredit",
    className: "with-purple",
    style: { borderColor: "rgb(177, 73, 255)", color: "rgb(177, 73, 255)" },
  },
  goToAnnual: { link: "/billing/plans", name: "navbar.goToAnnual" },
  upgradeToBusiness: {
    link: "billing/plans/plan_2/yearly",
    name: "navbar.upgradeToBusiness",
  },
  upgradeToOrganization: {
    link: "billing/plans/plan_3/yearly",
    name: "navbar.upgradeToOrganization",
  },
};
export default function UpgradeButton({
  hasSubscription,
  isBillingPage,
  organizationCredits,
  remaining,
}) {
  let action = null;
  if (organizationCredits.plan && remaining && remaining.organizationRemaining)
    action = getButtonAction({ organizationCredits, remaining });
  if (!(action && actions[action])) return null;
  if (action == "upgrade" && isBillingPage) return null;
  return (
    <button
      className="btn upgrade"
      onClick={() => (window.location = actions[action].link)}
      style={actions[action].style}
    >
      <span className={actions[action].className}>
        <FormattedMessage id={actions[action].name} />
      </span>
    </button>
  );
}
function getButtonAction({ organizationCredits, remaining }) {
  const numberOfLicences = organizationCredits.plan.numberOfSeats;
  const isYearly = organizationCredits.plan.numberOfMonths == 12;
  let highCreditConsumption = false;
  let action = null;
  if (
    organizationCredits.plan &&
    remaining &&
    remaining.organizationRemaining
  ) {
    let phoneCredits =
      organizationCredits.plan.phoneCredits.perSeat *
      organizationCredits.plan.numberOfMonths *
      organizationCredits.plan.numberOfSeats;

    highCreditConsumption =
      remaining.organizationRemaining.phoneCredits < phoneCredits / 2;
  }

  switch (organizationCredits.plan.planId) {
    case "0":
      action = "upgrade";
      break;
    case "plan_1":
      if (numberOfLicences == 1) {
        if (!highCreditConsumption) {
          action = "addMember";
        } else {
          action = isYearly ? "getMoreCredit" : "goToAnnual";
        }
      } else {
        if (!highCreditConsumption) {
          action = "addMember";
        } else {
          action = isYearly ? "upgradeToBusiness" : "goToAnnual";
        }
      }
      break;
    case "plan_2":
      if (numberOfLicences == 1) {
        if (!highCreditConsumption) {
          action = "addMember";
        } else {
          action = isYearly ? "getMoreCredit" : "goToAnnual";
        }
      } else {
        if (!highCreditConsumption) {
          action = "addMember";
        } else {
          action = "upgradeToOrganization";
        }
      }
      break;
    case "plan_3":
      if (isYearly) {
        if (!highCreditConsumption) {
          action = "addMember";
        } else {
          action = "getMoreCredit";
        }
      }
      break;
  }
  return action;
}
